import type { TranslationKey } from '@change-corgi/core/i18n';
import { translationKey } from '@change-corgi/core/i18n';
import type { IconComponent } from '@change-corgi/design-system-legacy/icons';
import {
	iconChangeOrg,
	iconChatBubble,
	iconEmail,
	iconFacebook,
	iconInstagram,
	iconLightbulb,
	iconLine,
	iconLinkedIn,
	iconLinktree,
	iconNextdoor,
	iconQrCode,
	iconReddit,
	iconSnapchat,
	iconTelegram,
	iconTiktok,
	iconTwitter,
	iconVk,
	iconWhatsapp,
	iconYoutube,
} from '@change-corgi/design-system-legacy/icons';
import type { ColorName } from '@change-corgi/design-system-legacy/theme';

export const OTHER_CHANNEL_KEY = 'other';

type ChannelSetting = {
	chartColor: ColorName;
	iconColor: ColorName;
	translationKey: TranslationKey;
	icon: IconComponent;
};
export const CHANNEL_SETTINGS: Record<string, ChannelSetting> = {
	change_email: {
		chartColor: 'primary-changeRed',
		iconColor: 'primary-changeRed',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.change_email',
		),
		icon: iconEmail,
	},
	email: {
		chartColor: 'secondary-purple',
		iconColor: 'secondary-purple',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.email',
		),
		icon: iconEmail,
	},
	facebook: {
		chartColor: 'social-facebook',
		iconColor: 'social-facebook',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.facebook',
		),
		icon: iconFacebook,
	},
	instagram: {
		chartColor: 'social-instagram',
		iconColor: 'social-instagram',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.instagram',
		),
		icon: iconInstagram,
	},
	line: {
		chartColor: 'social-line',
		iconColor: 'social-line',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.line',
		),
		icon: iconLine,
	},
	linkedin: {
		chartColor: 'social-linkedin',
		iconColor: 'social-linkedin',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.linkedin',
		),
		icon: iconLinkedIn,
	},
	linktree: {
		chartColor: 'social-linktree',
		iconColor: 'social-linktree',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.linktree',
		),
		icon: iconLinktree,
	},
	nextdoor: {
		chartColor: 'social-nextdoor',
		iconColor: 'social-nextdoor',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.nextdoor',
		),
		icon: iconNextdoor,
	},
	organic_search: {
		chartColor: 'primary-changeRed',
		iconColor: 'primary-changeRed',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.organic_search',
		),
		icon: iconLightbulb,
	},
	other: {
		chartColor: 'primary-black',
		iconColor: 'primary-black',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.other_channel',
		),
		icon: iconLightbulb,
	},
	promotion: {
		chartColor: 'primary-changeRed',
		iconColor: 'primary-changeRed',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.promotion',
		),
		icon: iconChangeOrg,
	},
	qr_code: {
		chartColor: 'primary-black',
		iconColor: 'primary-black',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.qr_code',
		),
		icon: iconQrCode,
	},
	reddit: {
		chartColor: 'social-reddit',
		iconColor: 'social-reddit',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.reddit',
		),
		icon: iconReddit,
	},
	sms: {
		chartColor: 'social-sms',
		iconColor: 'social-sms',
		translationKey: translationKey('corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.sms'),
		icon: iconChatBubble,
	},
	snapchat: {
		chartColor: 'social-snapchat',
		iconColor: 'primary-black',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.snapchat',
		),
		icon: iconSnapchat,
	},
	telegram: {
		chartColor: 'social-telegram',
		iconColor: 'social-telegram',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.telegram',
		),
		icon: iconTelegram,
	},
	tiktok: {
		chartColor: 'primary-black',
		iconColor: 'primary-black',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.tiktok',
		),
		icon: iconTiktok,
	},
	twitter: {
		chartColor: 'social-twitter',
		iconColor: 'social-twitter',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.twitter',
		),
		icon: iconTwitter,
	},
	vk: {
		chartColor: 'social-vk',
		iconColor: 'social-vk',
		translationKey: translationKey('corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.vk'),
		icon: iconVk,
	},
	whatsapp: {
		chartColor: 'social-whatsapp',
		iconColor: 'social-whatsapp',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.whatsapp',
		),
		icon: iconWhatsapp,
	},
	youtube: {
		chartColor: 'social-youtube',
		iconColor: 'social-youtube',
		translationKey: translationKey(
			'corgi.petition.starter_dashboard.petition_insights.signature_sources.channels.youtube',
		),
		icon: iconYoutube,
	},
};
